<script lang="ts" setup>
import { ToastProvider } from '@brighterly/lib-lumee-ui'

defineOptions({
  name: 'App',
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>

  <ToastProvider />
</template>
